import { useAbility } from '../../hooks/useAbility';

export const Can = ({ I, a, an, this: thisSubject, children, fallback = null }) => {
  const { ability } = useAbility();
  
  // I es la acción, a/an/this es el subject
  const action = I;
  const subject = a || an || thisSubject;
  
  if (!action || !subject) {
    return fallback;
  }

  const canPerformAction = ability.can(action, subject);

  return canPerformAction ? children : fallback;
};
